import SyTable from './index.vue'

const syTable = {
    install: function (Vue) {
        if (typeof window !== 'undefined' && window.Vue) {
        Vue = window.Vue
        }
     Vue.component(SyTable.name,SyTable);
    }
   }

export default syTable


// WEBPACK FOOTER //
// ./src/components/sy-table/index.js